import React, { lazy, Suspense } from 'react'
import { useTranslation } from 'react-i18next'
import SEO from '../components/SEO/SEO'
import { OrganizationSchema } from '../components/SEO/StructuredData'
import Header from '../components/organisms/Header/Header'
const Footer = lazy(() => import(/* webpackChunkName: "Footer" */ '../components/organisms/Footer'))
import TextSection from '../components/molecules/TextSection/TextSection'
import styles from './NotreAssociation.module.css'

/**
 * NotreAssociation - Page présentant l'association Burdigala Baggers
 */
const NotreAssociation = () => {
  const { t } = useTranslation('about')

  return (
    <div className={styles.page}>
      <SEO
        title={t('seo.title')}
        description={t('seo.description')}
        keywords={t('seo.keywords')}
        url="/notre-association"
        image="/common/burdigala-logo.webp"
      />
      <OrganizationSchema />
      <Header />
      <main className={styles.main}>
        <div className={styles.hero}>
          <h1 className={styles.heroTitle}>{t('hero.title')}</h1>
          <div className={styles.logoContainer}>
            <img
              src="/common/burdigala-logo.webp"
              alt={t('hero.logoAlt')}
              className={styles.logo}
            />
          </div>
        </div>

        <div className={styles.content}>
          <TextSection>
            <p>
              <strong>{t('intro.tagline')}</strong>
            </p>
            <p>{t('intro.welcome')}</p>
          </TextSection>

          <TextSection title={t('whoWeAre.title')}>
            <p>{t('whoWeAre.content')}</p>
          </TextSection>

          <TextSection title={t('values.title')}>
            <ul>
              <li>
                <strong>{t('values.inclusivity.title')}</strong>{' '}
                {t('values.inclusivity.content')}
              </li>
              <li>
                <strong>{t('values.conviviality.title')}</strong>{' '}
                {t('values.conviviality.content')}
              </li>
              <li>
                <strong>{t('values.solidarity.title')}</strong>{' '}
                {t('values.solidarity.content')}
              </li>
            </ul>
          </TextSection>

          <TextSection title={t('whyJoin.title')}>
            <p>{t('whyJoin.intro')}</p>
            <ul>
              <li>{t('whyJoin.benefits.training')}</li>
              <li>{t('whyJoin.benefits.events')}</li>
              <li>{t('whyJoin.benefits.support')}</li>
              <li>{t('whyJoin.benefits.community')}</li>
            </ul>
          </TextSection>

          <TextSection title={t('actions.title')}>
            <ul>
              <li>{t('actions.list.freeSessions')}</li>
              <li>{t('actions.list.partnerships')}</li>
              <li>{t('actions.list.tournaments')}</li>
              <li>{t('actions.list.initiatives')}</li>
            </ul>
          </TextSection>

          <TextSection title={t('testimonials.title')}>
            <blockquote>
              {t('testimonials.laurent')}
              <br />
              {t('testimonials.evelyneChristelle')}
              <br />
              {t('testimonials.thai')}
              <br />
              {t('testimonials.ousmane')}
            </blockquote>
          </TextSection>

          <TextSection title={t('callToAction.title')}>
            <p>
              {t('callToAction.content')}
              <br />
              {t('callToAction.contact')}
              <br />
              {t('callToAction.location')}{' '}
              <a
                href="https://www.google.com/maps/@44.7616136,-0.5660268,3a,75y,59.4h,90t/data=!3m7!1e1!3m5!1sbnbjAbwgsd2qCfysDPNicA!2e0!6shttps:%2F%2Fstreetviewpixels-pa.googleapis.com%2Fv1%2Fthumbnail%3Fcb_client%3Dmaps_sv.tactile%26w%3D900%26h%3D600%26pitch%3D0%26panoid%3DbnbjAbwgsd2qCfysDPNicA%26yaw%3D59.398426!7i16384!8i8192?entry=ttu&g_ep=EgoyMDI2MDIwNC4wIKXMDSoASAFQAw%3D%3D"
                target="_blank"
                rel="noopener noreferrer"
              >
                {t('callToAction.locationName')}
              </a>{' '}
              {t('callToAction.locationCity')}
            </p>
          </TextSection>

          <TextSection>
            <p>
              <strong>{t('closing.tagline')}</strong>
            </p>
            <p className={styles.hashtags}>{t('closing.hashtags')}</p>
          </TextSection>
        </div>
      </main>
      <Suspense fallback={<div style={{ height: '200px' }} />}>
        <Footer />
      </Suspense>
    </div>
  )
}

export default NotreAssociation
